import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet-async'
import { HeroSection } from '@/components/sections/HeroSection'
import { TextSection } from '@/components/sections/TextSection'

export default function Privacy() {
  const { t, i18n } = useTranslation('common')

  return (
    <>
      <Helmet>
        <title>{t('privacy.seo.title')}</title>
        <meta name="description" content={t('privacy.seo.description')} />
        <html lang={i18n.language} />
      </Helmet>

      <HeroSection
        imageSrc="/images/about-hero.jpg"
        title={t('privacy.hero.title')}
        slogan={t('privacy.hero.slogan')}
        primaryCta={{ label: t('buttons.contactUs'), to: 'contacts' }}
        secondaryCta={{ label: t('nav.services'), to: 'services' }}
      />

      <TextSection
        heading={t('privacy.intro.heading')}
        body={t('privacy.intro.body')}
        align="left"
      />

      <section className="py-12 md:py-16">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 space-y-12">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-brand-dark uppercase tracking-tight mb-4">
              {t('privacy.dataController.heading')}
            </h2>
            <p className="text-brand-text leading-relaxed whitespace-pre-line">
              {t('privacy.dataController.body')}
            </p>
          </div>

          <div>
            <h2 className="text-xl md:text-2xl font-bold text-brand-dark uppercase tracking-tight mb-4">
              {t('privacy.purpose.heading')}
            </h2>
            <p className="text-brand-text leading-relaxed mb-4">
              {t('privacy.purpose.body')}
            </p>
            <ul className="list-disc list-inside text-brand-text space-y-2">
              <li>{t('privacy.purpose.list.response')}</li>
              <li>{t('privacy.purpose.list.quotes')}</li>
              <li>{t('privacy.purpose.list.services')}</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl md:text-2xl font-bold text-brand-dark uppercase tracking-tight mb-4">
              {t('privacy.legalBasis.heading')}
            </h2>
            <p className="text-brand-text leading-relaxed">
              {t('privacy.legalBasis.body')}
            </p>
          </div>

          <div>
            <h2 className="text-xl md:text-2xl font-bold text-brand-dark uppercase tracking-tight mb-4">
              {t('privacy.retention.heading')}
            </h2>
            <p className="text-brand-text leading-relaxed">
              {t('privacy.retention.body')}
            </p>
          </div>

          <div>
            <h2 className="text-xl md:text-2xl font-bold text-brand-dark uppercase tracking-tight mb-4">
              {t('privacy.rights.heading')}
            </h2>
            <p className="text-brand-text leading-relaxed mb-4">
              {t('privacy.rights.body')}
            </p>
            <ul className="list-disc list-inside text-brand-text space-y-2">
              <li>{t('privacy.rights.list.access')}</li>
              <li>{t('privacy.rights.list.rectification')}</li>
              <li>{t('privacy.rights.list.erasure')}</li>
              <li>{t('privacy.rights.list.restriction')}</li>
              <li>{t('privacy.rights.list.objection')}</li>
              <li>{t('privacy.rights.list.portability')}</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl md:text-2xl font-bold text-brand-dark uppercase tracking-tight mb-4">
              {t('privacy.cookies.heading')}
            </h2>
            <p className="text-brand-text leading-relaxed">
              {t('privacy.cookies.body')}
            </p>
          </div>

          <div>
            <h2 className="text-xl md:text-2xl font-bold text-brand-dark uppercase tracking-tight mb-4">
              {t('privacy.contact.heading')}
            </h2>
            <p className="text-brand-text leading-relaxed whitespace-pre-line">
              {t('privacy.contact.body')}
            </p>
          </div>
        </div>
      </section>
    </>
  )
}
